import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

class ExifForm extends Component {
	constructor(props) {
		super(props);

        const { ex1, ex2, ex3, ex4, ex6, ex7, ex9, ex10, ex12, ex13, ex14, exifalign, exifcolor, exiffont, exifmargin, exifsize, exifwidth} = props.data.setting;
		this.state = {
            ex1 : (ex1 === "on"),
            ex2 : (ex2 === "on"),
            ex3 : (ex3 === "on"),
            ex4 : (ex4 === "on"),
            ex6 : (ex6 === "on"),
            ex7 : (ex7 === "on"),
            ex9 : (ex9 === "on"),
            ex10 : (ex10 === "on"),
            ex12 : (ex12 === "on"),
            ex13 : (ex13 === "on"),
            ex14 : (ex14 === "on"),

            exifwidth : exifwidth||1,
            exifalign : exifalign||1,
            exifcolor : exifcolor || '#777777',
            exiffont : exiffont || 'tahoma',
            exifmargin : exifmargin || '5px 0px 0px 0px',
            exifsize : exifsize || '8pt',
        };

	}

    componentDidMount() {
        const { plugin, onChange } = this.props
        const pluginData = this.generatePluginData();
		pluginData['validated'] = false
        onChange(pluginData);
    }

	@autobind
    handleChangeExifSize(value) {

        this.setState(
            Object.assign(this.state,  {
                exifsize: value.trim()
            })
        );

		this.changePluginData();
    }

    @autobind
    handleChangeExifMargin(value) {

        this.setState(
            Object.assign(this.state,  {
                exifmargin: value.trim()
            })
        );

        this.changePluginData();
    }

    @autobind
    handleChangeExifFont(value) {

        this.setState(
            Object.assign(this.state,  {
                exiffont: value.trim()
            })
        );

        this.changePluginData();
    }

    @autobind
    handleChangeExifColor(value) {

        this.setState(
            Object.assign(this.state,  {
                exifcolor: value.trim()
            })
        );

        this.changePluginData();
    }

	@autobind
    handleChangeExifWidth(item) {

		const value = item.value;
        this.setState(
            Object.assign(this.state,  {
                exifwidth: value
            })
        );

        this.changePluginData();
	}

	@autobind
    handleChangeExifAlign(item) {

        const value = item.value;
        this.setState(Object.assign(this.state,  {
                exifalign: value
            })
        );

        this.changePluginData();
    }

	@autobind
    handleExifCheckChange(e, property) {

        const checked = e.target.checked;
        this.setState(
            Object.assign(this.state,  {
                [property]: checked
            })
        );

        this.changePluginData();
	}

    @autobind
    changePluginData() {

        const { onChange } = this.props;

        const pluginData = this.generatePluginData();

        onChange(pluginData);
    }

    @autobind
    generatePluginData() {

		let pluginData = {
            ex1 : this.state.ex1? "on":"",
            ex2 : this.state.ex2? "on":"",
            ex3 : this.state.ex3? "on":"",
            ex4 : this.state.ex4? "on":"",
            ex6 : this.state.ex6? "on":"",
            ex7 : this.state.ex7? "on":"",
            ex9 : this.state.ex9? "on":"",
            ex10 : this.state.ex10? "on":"",
            ex12 : this.state.ex12? "on":"",
            ex13 : this.state.ex13? "on":"",
            ex14 : this.state.ex14? "on":"",

            exifwidth : this.state.exifwidth,
            exifalign : this.state.exifalign,
            exifcolor : this.state.exifcolor,
            exiffont : this.state.exiffont,
            exifmargin : this.state.exifmargin,
            exifsize : this.state.exifsize,
		};

		let validate = this.checkValidation(pluginData);

		return {
			setting : pluginData,
            validated: validate
		};
	}

    checkValidation(data) {

		let validate = true;

		const { exifmargin, exifsize, exifcolor } = data;

		if(exifmargin.length === 0) validate = false;
		if(exifsize.length === 0) validate = false;
		if(exifcolor.length === 0) validate = false;
		if(!(data.ex1=='on'||data.ex2=='on'||data.ex3=='on'||data.ex4=='on'||data.ex5=='on'||data.ex6=='on'||data.ex7=='on'||data.ex8=='on'||data.ex9=='on'||data.ex10=='on'||data.ex11=='on'||data.ex12=='on'||data.ex13=='on'||data.ex14=='on'))  validate = false;

		return validate;
	}

	render() {
		const { plugin } = this.props
		const { ex1, ex2, ex3, ex4, ex6, ex7, ex9, ex10, ex12, ex13, ex14, exifalign, exifcolor, exiffont, exifmargin, exifsize, exifwidth} = this.state;
		return (
			<div className="desc_plugin4">
				<p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
				<fieldset>
					<legend className="tit_set">표시 정보</legend>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck0" className="inp_check" defaultChecked={ex1} onChange={(e)=>this.handleExifCheckChange(e,'ex1')}/>
							<label htmlFor="inpCheck0" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">제조사</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={ex2} onChange={(e)=>this.handleExifCheckChange(e,'ex2')}/>
							<label htmlFor="inpCheck1" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">카메라 기종</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck2" className="inp_check" defaultChecked={ex3} onChange={(e)=>this.handleExifCheckChange(e,'ex3')}/>
							<label htmlFor="inpCheck2" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">촬영모드</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck3" className="inp_check" defaultChecked={ex4} onChange={(e)=>this.handleExifCheckChange(e,'ex4')}/>
							<label htmlFor="inpCheck3" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">측광모드</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck4" className="inp_check" defaultChecked={ex6} onChange={(e)=>this.handleExifCheckChange(e,'ex6')}/>
							<label htmlFor="inpCheck4" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">셔터속도</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck5" className="inp_check" defaultChecked={ex7} onChange={(e)=>this.handleExifCheckChange(e,'ex7')}/>
							<label htmlFor="inpCheck5" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">조리개</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck6" className="inp_check" defaultChecked={ex9} onChange={(e)=>this.handleExifCheckChange(e,'ex9')}/>
							<label htmlFor="inpCheck6" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">노출보정</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck7" className="inp_check" defaultChecked={ex10} onChange={(e)=>this.handleExifCheckChange(e,'ex10')}/>
							<label htmlFor="inpCheck7" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">초점거리</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck8" className="inp_check" defaultChecked={ex12} onChange={(e)=>this.handleExifCheckChange(e,'ex12')}/>
							<label htmlFor="inpCheck8" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">ISO</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck9" className="inp_check" defaultChecked={ex13} onChange={(e)=>this.handleExifCheckChange(e,'ex13')}/>
							<label htmlFor="inpCheck9" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">플래시 사용</span>
							</label>
					</div>
					<div className="check_blog">
						<input type="checkbox" id="inpCheck10" className="inp_check" defaultChecked={ex14} onChange={(e)=>this.handleExifCheckChange(e,'ex14')}/>
							<label htmlFor="inpCheck10" className="lab_check">
								<span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
								<span className="txt_check">촬영시각</span>
							</label>
					</div>
				</fieldset>
				<fieldset>
					<legend className="tit_set">스타일</legend>
					<div className="item_set item_sub">
						가로폭은
						<TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'블로그 스킨', value:'1' },
                            { label:'사진 크기', value:'2' },
                        ]} selected={exifwidth} onSelect={this.handleChangeExifWidth}/>
						에 맞추고
						<TSelectForm className="opt_set opt_plugin2" items={[
                            { label:'왼쪽으로', value:'1' },
                            { label:'가운데로', value:'2' },
                            { label:'오른쪽으로', value:'3' },
                        ]} selected={exifalign} onSelect={this.handleChangeExifAlign}/>
						정렬합니다.
					</div>
					<div className="item_set item_sub">
						글꼴
						<TInputForm className="tf_set tf_set160" onChange={this.handleChangeExifFont} value={exiffont} />
						여백
						<TInputForm className="tf_set tf_set160" onChange={this.handleChangeExifMargin} value={exifmargin} />
						<span className="txt_other">* 상px 우px 하px 좌px</span>
					</div>
					<div className="item_set item_sub item_subnone">
						크기
						<TInputForm className="tf_set tf_set160" onChange={this.handleChangeExifSize} value={exifsize} />
						색상
						<TInputForm className="tf_set tf_set160" onChange={this.handleChangeExifColor} value={exifcolor} />
						<a href="https://html-color-codes.info/Korean/" target="_blank" className="link_other">색상표 보기</a>
					</div>
				</fieldset>
                {this.props.saveButton()}
			</div>
		)
	}
}

ExifForm.propTypes = {
	plugin: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired
}

export default ExifForm
